module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 myclass",
    attrs: {
      "id": "لماذا-أرتدي-الاسود"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لماذا أرتدي الاسود؟")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "why-im-wearing-black"
    }
  }, [_c('h2', [_vm._v("? Why "), _c('strong', [_vm._v("I’m")]), _vm._v(" wearing black ")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنا لا أرتدي الأسود لأني أقيم عزاء، أو لأني بأيام حدادي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بل لأني أريد أن أتقبّل ما تقدمة الحياة لي بتفاؤل وصدرٍ رحبٍ، الأسود يمتص كُل ما هو ليس جميل ويعيد حياكته لي بشيءٍ أجمل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يُمد لي السعادة كما يُمد الأكسجين الحياة، يبعث بي الأمل كما تفعل الشمس عند شروقها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لذا.. لا شيء مُحزن يرتبط به أبداً، حتى في وقت العزاء، هو فقط يخفف الحُزن الذي يتلقاه الجميع عند فقد عزيز.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a49197e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch006.vue
// module id = 84
// module chunks = 0